export const PC=["Coffee","Breakfast Sandwiches","Crepes","Lobster","Bakery","Popovers","Bubble Tea","Other Food","Other Beverages","Retail"];

export const PCM={"Sig Lattes":"Coffee","Espresso":"Coffee","Coffee":"Coffee","Other Drinks":"Other Beverages","Bakery":"Bakery","Popovers":"Popovers","Food":"Other Food","Bottled":"Retail"};

export const PCO={bs:"Breakfast Sandwiches",hcc:"Crepes",nsc:"Crepes",nbc:"Crepes",nsbc:"Crepes",bjc:"Crepes",wbc:"Crepes",lsc:"Crepes",suc:"Crepes",ntc:"Crepes",chc:"Crepes",hec:"Crepes",lr:"Lobster",lmc:"Lobster",lbt:"Lobster",lgc:"Lobster",lwc:"Lobster",po:"Popovers",boba:"Bubble Tea",ccs:"Other Food"};

export function getPC(it){
  // Toast items: use sales_category directly (Food, Liquor, Draft Beer, Bottled Beer, Wine)
  if(it.salesCat)return it.salesCat;
  // Stadium-specific: match by ID prefix, then category name
  for(const[p,pc] of Object.entries(PCO))if(it.id.startsWith(p))return pc;
  return PCM[it.cat]||"Other Food";
}

export const DEFAULT_SALES_CATS=['Food','Liquor','Beer','Wine'];
export const getCategories=(settings)=>settings?.salesCategories?.length?settings.salesCategories:DEFAULT_SALES_CATS;
// Union of configured categories + any categories present in salesByDate for the given date range
export function getAllVisibleCategories(settings, salesByDate, filterFn) {
  const configured = new Set(getCategories(settings));
  if (salesByDate) {
    for (const [d, row] of Object.entries(salesByDate)) {
      if (filterFn && !filterFn(d)) continue;
      for (const cat of Object.keys(row)) { configured.add(cat); }
    }
  }
  return [...configured];
}

export const WR=["Dropped/Spilled","Expired/End of Day","Overcooked/Burnt","Wrong Order","Quality Issue","Damaged","Training"];

export const WEATHER=["☀ Sunny","🌤 Partly Cloudy","⛅ Cloudy","🌧 Rainy","⛈ Stormy","🌫 Foggy"];

export const DAYS=["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
